import { render, staticRenderFns } from "./UiEditor5.vue?vue&type=template&id=c235176c&scoped=true"
import script from "./UiEditor5.vue?vue&type=script&lang=js"
export * from "./UiEditor5.vue?vue&type=script&lang=js"
import style0 from "./UiEditor5.vue?vue&type=style&index=0&id=c235176c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c235176c",
  null
  
)

export default component.exports